(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/event-analyses.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/event-analyses.js');
"use strict";


const ReactIcon = svs.ui.ReactIcon;
const EventAnalysis = svs.component.analyze.EventAnalysis;
const EventAnalyses = _ref => {
  let analyses = _ref.analyses,
    isExpanded = _ref.isExpanded,
    onToggleExpand = _ref.onToggleExpand,
    authors = _ref.authors,
    branding = _ref.branding,
    eventTypeId = _ref.eventTypeId,
    sportType = _ref.sportType,
    drawNumber = _ref.drawNumber,
    productId = _ref.productId;
  return React.createElement("li", {
    className: "event-analyses"
  }, React.createElement("div", {
    className: "pg_analyse__event"
  }, React.createElement("div", {
    className: "pg_analyse__event__title"
  }, React.createElement("span", {
    className: "margin-right"
  }, analyses[0].eventNumber), analyses[0].title), analyses.map((matchAnalysis, index) => {
    if (!authors[index].selected) {
      return null;
    }
    return React.createElement(EventAnalysis, {
      branding: branding,
      drawNumber: drawNumber,
      eventTypeId: eventTypeId,
      isExpanded: isExpanded,
      key: matchAnalysis.id,
      matchAnalysis: matchAnalysis,
      productId: productId,
      sportType: sportType
    });
  })), React.createElement("div", {
    className: "event-analyses-divider"
  }), React.createElement("div", {
    className: "event-analyses-expander",
    onClick: () => {
      onToggleExpand(analyses[0].gameInfo.sportEvents[0]);
    }
  }, React.createElement(ReactIcon, {
    icon: isExpanded ? 'menu-up' : 'menu-down',
    size: "100"
  })));
};
setGlobal('svs.component.analyze.EventAnalyses', EventAnalyses);

 })(window);